import React from 'react';
import '../../datatrace/TransactionHistory.css';

function ApiResponseModal({ isOpen, title, data, requestPayload, transactionInfo, onClose }) {
  if (!isOpen || !data) return null;

  // Format JSON for display
  const formatJSON = (obj) => {
    try {
      return JSON.stringify(obj, null, 2);
    } catch (e) {
      return String(obj);
    }
  };

  return (
    <div className="transaction-modal-overlay" onClick={onClose}>
      <div className="transaction-modal" onClick={(e) => e.stopPropagation()}>
        <div className="transaction-modal-header">
          <h3>{title}</h3>
          <button className="modal-close-btn" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="transaction-modal-content">
          {/* Response Data Section - Moved to #1 */}
          <div className="transaction-modal-section">
            <h4>Response Data</h4>
            <div style={{ marginBottom: '12px' }}>
              <button
                className="copy-json-button"
                onClick={() => {
                  navigator.clipboard.writeText(formatJSON(data));
                  alert('Response JSON copied to clipboard!');
                }}
                style={{
                  background: '#667eea',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  padding: '8px 16px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'background 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.background = '#5568d3'}
                onMouseLeave={(e) => e.target.style.background = '#667eea'}
              >
                📋 Copy Response JSON
              </button>
            </div>
            <pre className="transaction-modal-code">
              {formatJSON(data)}
            </pre>
          </div>

          {/* Transaction Info Section */}
          {transactionInfo && (
            <div className="transaction-modal-section">
              <h4>Transaction Info</h4>
              <div className="transaction-info-grid">
                {transactionInfo.transactionId && (
                  <div>
                    <strong>Transaction ID:</strong>
                    {transactionInfo.transactionId}
                  </div>
                )}
                {transactionInfo.status && (
                  <div>
                    <strong>Status:</strong>
                    {transactionInfo.status}
                  </div>
                )}
                {transactionInfo.address && (
                  <div>
                    <strong>Address:</strong>
                    {transactionInfo.address}
                  </div>
                )}
                {transactionInfo.product && (
                  <div>
                    <strong>Product:</strong>
                    {transactionInfo.product}
                  </div>
                )}
                {transactionInfo.confirmationNumber && (
                  <div>
                    <strong>Confirmation:</strong>
                    {transactionInfo.confirmationNumber}
                  </div>
                )}
                {transactionInfo.timestamp && (
                  <div>
                    <strong>Timestamp:</strong>
                    {new Date(transactionInfo.timestamp).toLocaleString()}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Request Payload Section */}
          {requestPayload && (
            <div className="transaction-modal-section">
              <h4>Request Payload</h4>
              <pre className="transaction-modal-code">
                {formatJSON(requestPayload)}
              </pre>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ApiResponseModal;
